import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import VideoPlayer from "../../../core/video/VideoPlayer";
import VideoPlayerDispenserHelper from "../../../core/video/VideoPlayerDispenserHelper";
import VideoPlayerEvent from "../../../core/video/VideoPlayerEvent";
import NGTAssetLocator from "../../../ngt/base/NGTAssetLocator";
import DebugEvent from "../../../ngt/debug/DebugEvent";
import DebugModel from "../../debug/model/DebugModel";
import ProgressModel from "../../progress/model/ProgressModel";
import SaveGameEvent from "../../savegame/event/SaveGameEvent";
import SaveGameModel from "../../savegame/model/SaveGameModel";
import { SaveGameVideoIds } from "../../savegame/model/SaveGameVideoIds";

export default class GameIntroductionVideoPlayer extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTAssetLocator} assetLocator 
     * @param {MediatorManager} mediatorManager 
     * @param {LanguagePack} languagePack
     * @param {ProgressModel} progressModel
     */
    constructor(target, dispatcher, assetLocator, mediatorManager, languagePack, progressModel) {
        super(target, dispatcher);

        this._assetLocator = assetLocator;
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
        this._progressModel = progressModel;

        this._handleSkipContentBound = this.handleSkipContent.bind(this);
    }

    initialize() {
        super.initialize();

        if (DebugModel.skipVideos) {
            this.end();
            return;
        }

        const videoId = SaveGameVideoIds.GAME_INTRO;
        if (this._progressModel.hasSeenVideo(videoId)) {
            console.log(`[StoryIntroductionVideoPlayer] Learner has already seen the intro video. Skipping it...`);
            this.end();
            return;
        }

        this._showVideo(VideoPlayerDispenserHelper.videoPlayerIds.mainVideoPlayer);

        // Persist video seen.
        this._progressModel.markVideoAsSeen(videoId);
        this.dispatch(SaveGameEvent.SAVE);

        this._pauseVideoPlayerButton = this._mediatorManager.createMediator(SkinFactory.getSkin(SkinKeyRegistry.PAUSE_VIDEO_PLAYER_BUTTON_SKIN), SkinKeyRegistry.PAUSE_VIDEO_PLAYER_BUTTON_SKIN);
        this._pauseVideoPlayerButton.setVideoPlayer(this.videoPlayer);
        this._pauseVideoPlayerButton.setParent(this._target);

        // const skipVideoDOMButton = document.getElementById('skipVideoButtonLabel');
        // if (skipVideoDOMButton) {
        //     skipVideoDOMButton.innerText = this._languagePack.getText('video.skipButtonLabel');
        // }
    }

    destroy() {
        super.destroy();

        this._pauseVideoPlayerButton.destroy();

        this._dispatcher.removeEventListener(DebugEvent.SKIP_CONTENT, this._handleSkipContentBound);

        if (!!this.videoPlayer) {
            this.videoPlayer.destroy();
            this.videoPlayer = null;
        }
    }

    _showVideo(videoClass) {
        const videoURL = this._assetLocator.getLocalizedVideoLocationForID(GameIntroductionVideoPlayer.VIDEO_ID);
        console.log(`[StoryIntroductionVideoPlayer] Video URL: ${videoURL}`);
        const subtitlesURL = this._assetLocator.getSubtitleLocationForVideoID(GameIntroductionVideoPlayer.VIDEO_ID);
        this.videoPlayer = new VideoPlayer(videoClass);
        this.videoPlayer.autoRetry = false; // Set auto retry to false as we want to show an error message that will trigger the retry
        this.videoPlayer.addEventListener(VideoPlayerEvent.PLAYBACK_FINISHED, this.handleVideoEnded, this);
        this.videoPlayer.addEventListener(VideoPlayerEvent.PLAYBACK_READY, this.handleVideoReady, this);
        this.videoPlayer.load(videoURL, null, subtitlesURL, true, false);

        this._dispatcher.addEventListener(DebugEvent.SKIP_CONTENT, this._handleSkipContentBound);
    }

    handleVideoReady() {
        this.videoPlayer.play();
    }

    handleSkipContent() {
        this.end();
    }

    handleVideoEnded() {
        this.end();
    }

    end() {
        if (this.videoPlayer) {
            this.videoPlayer.removeEventListener(VideoPlayerEvent.PLAYBACK_FINISHED, this.handleVideoEnded);
            this.videoPlayer.removeEventListener(VideoPlayerEvent.PLAYBACK_READY, this.handleVideoReady);

            this.videoPlayer.stop();
        }
        this.closeScreen(this._target);
        this.openScreen(SkinKeyRegistry.PLAYER_NAME_INPUT_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
    }

    setPaused(value) {
        console.log(`SimulationIntroductionVideoPlayer.setPaused: ${value}`);
        if (value) {
            this.videoPlayer.pause();
        } else {
            this.videoPlayer.resume();
        }
    }

    _handlePauseGame(evt) {
        this.setPaused(true);
    }

    _handleResumeGame(evt) {
        this.setPaused(false);
    }
}

GameIntroductionVideoPlayer.VIDEO_ID = `game_intro`;